export default __webpack_public_path__ + "static/Loccitane-255e1d3470c60eb3e2ab7a7fb7b6f42f.png";